// WORKAROUND handle different states until we get rid of immutable reducers
export default (state: any) => (state.get ? state.get('normalizr') : state);
